var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-numbers"},_vm._l((_vm.pageNumbers),function(pageNumber,idx){return _c('a',{key:idx,class:{
      active: _vm.page === pageNumber,
      disabled: pageNumber === '<' && _vm.page === 1 || pageNumber === '>' && _vm.page === _vm.pages,
      'button-previous': pageNumber === '<',
      'button-next': pageNumber === '>',
      'button-number': Number.isInteger(pageNumber),
      'elipses': pageNumber === '...'
    },on:{"click":function($event){return _vm.$emit('goto-page', pageNumber)}}},[(pageNumber === '<')?_c('span',[_vm._v("<")]):(pageNumber === '>')?_c('span',[_vm._v(">")]):(pageNumber === '...')?_c('span',[_vm._v("…")]):_c('span',[_vm._v(_vm._s(_vm.$tn(pageNumber)))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }